module.exports = __webpack_public_path__ + "img/st550-nieuwe-logo-transparant.f33c293f.png";